import FullInfoField from 'components/FullInfoField/FullInfoField';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from 'modules/CustomersAndRestaurants/Customers/CustomerFullInfo/customerFullInfoState/customerFullInfoContext';
import React, { useContext } from 'react';

const BaseMccField: React.FC = () => {
	const { customerForFullInfo } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);

	return <FullInfoField label="baseMccLabel" value={customerForFullInfo?.merchantCategoryCode?.baseMcc} />;
};

export default BaseMccField;
